import { render, staticRenderFns } from "./TableFiveGames.vue?vue&type=template&id=479b41e2&scoped=true&"
import script from "./TableFiveGames.vue?vue&type=script&lang=js&"
export * from "./TableFiveGames.vue?vue&type=script&lang=js&"
import style0 from "./TableFiveGames.vue?vue&type=style&index=0&id=479b41e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b41e2",
  null
  
)

export default component.exports